<template>
  <div
    v-if="$login.can('companies.create')"
    class="companies-create"
  >
    <page-header header="Create new company from ISIN">
    </page-header>
    <div class="mt-4">
      <form @submit.prevent="createCompany">
        <div class="form-group">
          <label for="company-sector">Name</label>
          <input class="form-control" v-model="name" />
        </div>
        <div class="form-group">
          <label for="company-sector">ISIN</label>
          <input class="form-control" v-model="isin" />
        </div>
        <button
        type="submit"
        class="btn btn-primary"
      >
        Save
      </button>
      </form>
    </div>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table'
import {infoNotification, successNotification} from '@/notifications'
import {debounce} from '@/helpers'
import RequestForm from './Form'

export default {
  name: 'CreateCompanyFromIsin',

  props: {
  },

  components: {
    // VueGoodTable,
    // RequestForm,
  },

  watch: {
  },

  data () {
    return {
      isin: '',
      name: '',
    }
  },

  methods: {

    async createCompany () {
      const name = encodeURI(this.name).replace(/\//g, '')
      await this.$http.get(`companies/rapido/create-from-isin/${this.isin}/${name}`)

      this.$notify(infoNotification('You will recieve a notification when this company has been created.'))

      this.$router.replace({name: 'companies'})
    },

  },

}
</script>

<style lang="scss">
  $aside-width: 568px;
  .request-form {
    position: fixed;
    top: 0;
    right: -$aside-width;
    width: $aside-width;
    height: 100vh;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    background: white;
    z-index: 1000;
    box-shadow: 0 7px 32px rgba(0, 0, 0, 0.15);
    transition: right 0.3s ease;

    &--active {
      right: 0;
    }
  }
</style>
